import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {MessageHandlerComponent} from '../../components/Controls/MessageHandler.component';
import {BlockComponent} from '../../components/Controls/Block.component';
import {RequestValidationMessagesComponent} from '../../components/Requests/RequestValidationMessages.component';


@Component({
  selector: 'my-upload_completion_info',
  templateUrl: './UploadCompletionInfo.component.html'
})
export class UploadCompletionInfoComponent implements OnInit {


    userInfo: ent.UserInfo;
    @ViewChild(MessageHandlerComponent) messageHandlerComponent: MessageHandlerComponent;
    @ViewChild(BlockComponent) blockComponent: BlockComponent;
    @ViewChild(RequestValidationMessagesComponent) requestValidationMessagesComponent: RequestValidationMessagesComponent;
    uploadURL: string;
    requests: ent.Request[];
    selectedRequests: ent.Request[] = [];
    fileName: string;
    displayCompleteDialog: boolean;


    constructor(private configService: serv.ConfigService, private authenticationService: serv.AuthenticationService, 
        private router: Router, private requestService: serv.RequestService) 
    { 
      this.uploadURL = configService.appConfig.UrlBase + Constants._UPLOAD_COMPLETION_INFO_METHOD;

    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
    }

    onBeforeSend(event: any){
        event.xhr.setRequestHeader(Constants._HEADER_EMPLOYEE_ID, this.userInfo.Employee.ID);
    }

    onUpload(event: any){
        this.blockComponent.blocked = true;
        var files: File[] = [];
        files = event.files;
        var validationMessage: ent.ValidationMessage = {Category: "", MessageText: files.length.toString() + " Files Uploaded"};
        var response: ent.Response = {Success:true, ValidationMessages: [validationMessage]};
        this.messageHandlerComponent.handleResponse(response);

        if (files.length > 0){
            var processCompletionInfoRequest: ent.ProcessCompletionInfoRequest = {EmployeeID: this.userInfo.Employee.ID, FileName: files[0].name};
            this.requestService.processCompletionInfo(processCompletionInfoRequest).subscribe(x=>
                {
                    this.requests = x.Requests;
                    this.messageHandlerComponent.handleResponse(x);
                    this.blockComponent.blocked = false;
                }, err => {
                    this.blockComponent.blocked = false;
                });
        }
    }

    showRequests(): boolean{
        if (this.requests && this.requests.length > 0){
            return true;
        }
        return false;
    }

    disableComplete(): boolean{
        if (!this.selectedRequests || this.selectedRequests.length == 0){
            return true;
        }
        return false;
    }

    onCompleteClick(event: any){
        this.displayCompleteDialog = true;
    }
    
    onCancelClick(event: any){
        this.requests = [];
    }

    onCompleteYesClick(event: any){
        
        this.doComplete();
        
        this.displayCompleteDialog = false;
    }

    doComplete(){
        this.blockComponent.blocked = true;
        var completeRequest: ent.CompleteRequestsRequest = {Requests: this.selectedRequests, SaveCompletionNumbers: true, Employee: this.userInfo.Employee};
        this.requestService.completeRequest(completeRequest).subscribe(x=>
            {
                if (x.Success){
                    this.messageHandlerComponent.handleResponse(x);
                }
                else{
                    this.requestValidationMessagesComponent.displayDialog = true;
                    this.requestValidationMessagesComponent.messages = [];
                    for (var vm of x.ValidationMessages){
                        this.requestValidationMessagesComponent.messages = [...this.requestValidationMessagesComponent.messages, vm];
                    }
                    
                }
                this.blockComponent.blocked = false;
            });
    }
    
    onCompleteCancelClick(event: any){
        this.displayCompleteDialog = false;
    }

    onHideCompleteDialog(event: any){
        this.displayCompleteDialog = false;
    }
    
}